module.exports = __webpack_public_path__ + "img/home_bg_8.ed6735e9.png";